export const changeRouteValue = payload => {
    return { type: "view/ROUTE_VALUE", payload }
}
